import { NodeViewRendererProps } from '@tiptap/core';
import { Image } from '@tiptap/extension-image';

export const ResizableImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: 'auto',
        renderHTML: attributes => ({
          width: attributes['width'],
          style: `width: ${attributes['width']}; height: ${
            attributes['height'] || 'auto'
          }`,
        }),
      },
      height: {
        default: 'auto',
      },
      textAlign: {
        default: 'left',
        renderHTML: attributes => ({
          'data-text-align': attributes['textAlign'],
        }),
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    // 뷰어(innerHTML)에서 보일 때의 HTML 구조를 정의합니다.
    // 기존 Image의 renderHTML(img 태그만 생성)을 따르되, 추가한 속성들이 포함되게 합니다.
    return ['img', HTMLAttributes];
  },

  addNodeView() {
    return ({ node, getPos, editor }: NodeViewRendererProps) => {
      const container = document.createElement('span');
      container.classList.add('resizable-image-container');

      const img = document.createElement('img');
      img.src = node.attrs['src'];
      img.style.width = node.attrs['width'];
      img.style.height = node.attrs['height'];

      // 정렬 정보를 컨테이너와 이미지 모두에 부여 (에디터 내 시각화용)
      if (node.attrs['textAlign']) {
        container.setAttribute('data-text-align', node.attrs['textAlign']);
        img.setAttribute('data-text-align', node.attrs['textAlign']);
      }

      const handle = document.createElement('div');
      handle.classList.add('resize-handle');

      container.appendChild(img);
      container.appendChild(handle);

      let startX: number, startWidth: number;

      handle.addEventListener('mousedown', e => {
        e.preventDefault();
        startX = e.clientX;
        startWidth = img.clientWidth;

        const onMouseMove = (e: MouseEvent) => {
          const currentWidth = startWidth + (e.clientX - startX);
          img.style.width = `${currentWidth}px`;
        };

        const onMouseUp = () => {
          document.removeEventListener('mousemove', onMouseMove);
          document.removeEventListener('mouseup', onMouseUp);

          if (typeof getPos === 'function') {
            editor.commands.updateAttributes(this.name, {
              width: `${img.clientWidth}px`,
            });
          }
        };

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      });

      return {
        dom: container,
        contentDOM: null,
        update: updatedNode => {
          if (updatedNode.type.name !== this.name) return false;
          img.src = updatedNode.attrs['src'];
          img.style.width = updatedNode.attrs['width'];
          img.style.height = updatedNode.attrs['height'];
          if (updatedNode.attrs['textAlign']) {
            container.setAttribute(
              'data-text-align',
              updatedNode.attrs['textAlign']
            );
            img.setAttribute('data-text-align', updatedNode.attrs['textAlign']);
          } else {
            container.removeAttribute('data-text-align');
            img.removeAttribute('data-text-align');
          }
          return true;
        },
      };
    };
  },
});
